<template>
  <img
    class="bike-illustration"
    :src="imageUrl"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useBikeStore } from '@/store/bikeStore'
import { PreviewImage } from '@/types/preview'

import previewDropbarBike from '@/assets/preview-dropbar-bike.png'
import previewDropbarHandlebar from '@/assets/preview-dropbar-handlebar.png'
import previewDropbarHoods from '@/assets/preview-dropbar-hoods.png'
import previewFlatbarBike from '@/assets/preview-flatbar-bike.png'
import previewFlatbarGrips from '@/assets/preview-flatbar-grips.png'
import previewFlatbarHandlebar from '@/assets/preview-flatbar-handlebar.png'
import previewSaddle from '@/assets/preview-saddle.png'
import previewTribarBike from '@/assets/preview-tribar-bike.png'
import previewTribarHandlebar from '@/assets/preview-tribar-handlebar.png'
import previewTribarPads from '@/assets/preview-tribar-pads.png'

const imageMap: Record<PreviewImage, string> = {
  [PreviewImage.DROPBAR_BIKE]: previewDropbarBike,
  [PreviewImage.DROPBAR_HANDLEBAR]: previewDropbarHandlebar,
  [PreviewImage.DROPBAR_HOODS]: previewDropbarHoods,
  [PreviewImage.FLATBAR_BIKE]: previewFlatbarBike,
  [PreviewImage.FLATBAR_GRIPS]: previewFlatbarGrips,
  [PreviewImage.FLATBAR_HANDLEBAR]: previewFlatbarHandlebar,
  [PreviewImage.SADDLE]: previewSaddle,
  [PreviewImage.TRIBAR_BIKE]: previewTribarBike,
  [PreviewImage.TRIBAR_HANDLEBAR]: previewTribarHandlebar,
  [PreviewImage.TRIBAR_PADS]: previewTribarPads,
}

const bikeStore = useBikeStore()
const { bikePreview } = storeToRefs(bikeStore)

const imageUrl = computed(
  () => imageMap[bikePreview.value] ?? previewDropbarBike,
)
</script>

<style lang="scss">
.bike-illustration {
  width: 100%;
  height: auto;
}
</style>
